class ImgUrlConstants {
  static BACKEND_BASE_URL = "https://backend.gebootcamp.com";
  // static BACKEND_BASE_URL = "http://localhost:8080";

  //homepage
  static BOOKLET_URL = `${this.BACKEND_BASE_URL}/files/homebanner/booklet.pdf`;
  static HOMEBANNER_VIDEO_URL = `${this.BACKEND_BASE_URL}/files/homebanner/homebannerVideo.mp4`;
  static EDITION_TIMELINE_IMG = `${this.BACKEND_BASE_URL}/files/editionTimeline/editionTimeline.png`;

  //past geb page
  static PAST_GEB_SPEAKER_PIC = `${this.BACKEND_BASE_URL}/files/geb/pastGeb/`;
  static PAST_GEB_BUSINESS_PIC = `${this.BACKEND_BASE_URL}/files/geb/pastGeb/`;
  static PAST_GEB_EXPERIENCE_PIC = `${this.BACKEND_BASE_URL}/files/geb/pastGeb/`;

  //upcomming GEB page
  static UPCOMMING_GEB_INTRO_PIC = `${this.BACKEND_BASE_URL}/files/geb/currentGeb/introPic.png`;
  static UPCOMMING_GEB_WHY_PIC = `${this.BACKEND_BASE_URL}/files/geb/currentGeb/whyPic.png`;

  //organizers page
  static ORGANIZERS_PROFILE_PIC_URL = `${this.BACKEND_BASE_URL}/files/organizers/`;

  //gallary page
  static GALLERY_PIC_URL = `${this.BACKEND_BASE_URL}/files/geb/gallery`;

  //blogs page
  static BLOG_PIC_URL = `${this.BACKEND_BASE_URL}/files/blog`;

  //advisor page
  static ADVISOR_PIC_URL = `${this.BACKEND_BASE_URL}/files/advisor`;

}

export default ImgUrlConstants;
